import type { SWRConfiguration } from 'swr';
import type { IApiResponse } from 'src/types/api';
import type { IRestaurantData } from 'src/types/restaurant';

import useSWR from 'swr';
import { useMemo } from 'react';

import { fetcher, endpoints } from 'src/utils/axios';

const swrOptions: SWRConfiguration = {
  revalidateIfStale: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  errorRetryInterval: 3000,
  errorRetryCount: 5,
};

export function useGetRestaurants() {
  const url = endpoints.restaurant.list;

  const { data, isLoading, error, isValidating, mutate } = useSWR<IApiResponse<IRestaurantData[]>>(
    url,
    fetcher,
    swrOptions
  );

  const memoizedValue = useMemo(
    () => ({
      restaurants: data?.data || [],
      loading: isLoading,
      error,
      labelsValidating: isValidating,
      isEmpty: !isLoading && !data?.data?.length,
      mutate,
    }),
    [data?.data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}
